module.exports = __webpack_public_path__ + "static/media/Cats eyes 04_SVENSKA-mixdown-ny.dafe41c9.mp3";